import { useLocale } from "../../../hooks/useLocale";
import { msg } from "../../../locales/translate";
import { HBox, VBox } from "@ui/box/Box";
import Button from "@ui/button/Button";
import Panel from "@ui/panel/Panel";
import Spacer from "@ui/spacer/Spacer";
import { Typo } from "@ui/text/Typo";
import { GD } from "../../../GD";

export const SessionTerminatedPopup = () => {
	useLocale();
	const request = GD.S_SESSION_TERMINATED_POPUP.use();

	if (!request) return null;

	const closePopup = () => GD.S_SESSION_TERMINATED_POPUP.invoke(null);

	return (
		<Panel
			growContent
			sx={{
				maxWidth: "560px",
				minWidth: "420px",
				maxHeight: "90vh",
			}}
			decorator="absolute"
			label={msg("sessionTerminated")}
			onClose={closePopup}>
			<VBox gap="16px" sx={{ overflow: "auto", flexGrow: 1, padding: "14px 0px 10px" }}>
				<Typo variant="text">{request.message}</Typo>
			</VBox>

			<Spacer size="20px" />

			<HBox sx={{ width: "100%" }}>
				<Button sx={{ flex: 1 }} title={msg("ok")} onClick={closePopup} />
			</HBox>
		</Panel>
	);
};
